import { getId, Modal, Icon, SearchBox } from "@fluentui/react";
import { useRef, useEffect } from "react";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { usePopularWebsiteVM } from "../viewmodels/PopularWebsiteVM";
import PopularWebsiteView from "./PopularWebsiteView";

export type AllPopularWebsiteProps = {
    onClose: () => void;
}

export default function AllPopularWebsiteView({ onClose }: AllPopularWebsiteProps) {
    const hasLoaded = useRef(false);
    const vm = usePopularWebsiteVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList(0);
    }, [vm]);

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const headerView = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>Popular Websites</div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    const actionRow = () => {
        return <div className="ms-Grid-row container pb-10">
            <div className={width12 + " center"}>
                <span className="pl-10">Sort By:</span>
                <span className="pl-10 cursor font-bold" onClick={() => vm.onSort(false)}>
                    Popularity
                </span>
                <span className="pl-15 cursor font-bold" onClick={() => vm.onSort(true)}>
                    Name
                </span>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(800)}
        >
            {headerView()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body"}>
                {actionRow()}
                <PopularWebsiteView key={vm.listHash} list={vm.list} />
            </div>
        </Modal>
    </>;
}